import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {InsoleMaterialRepository} from "./impl/service/ngrx/insoleMaterial.repository";
import {InsoleMaterialDataService} from "./impl/service/ngrx/insoleMaterial.data.service";
import {InsoleMaterialDataServiceAdapter} from "./impl/service/ngrx/insoleMaterial.data.service.adapter";
import {InsoleMaterialSummaryDataServiceAdapter} from "./impl/service/ngrx/insoleMaterialSummary.data.service.adapter";
@NgModule({
    providers: [
        InsoleMaterialRepository,
        InsoleMaterialDataService,
        InsoleMaterialDataServiceAdapter,
        InsoleMaterialSummaryDataServiceAdapter
    ],
})
export class InsoleMaterialModule {
     constructor(entityDataService: EntityDataService,
                 entityServices: EntityServices,
                 repository: InsoleMaterialRepository,
                 dataService: InsoleMaterialDataService,
    ) {

        entityDataService.registerServices({
            InsoleMaterial: dataService,
        });

        entityServices.registerEntityCollectionServices({
            InsoleMaterial: repository,
        });

        // errorMessages.set(PARTNER_SAVE_PERSON_ALREADY_PART_OF_THIS_TYPE, 'La personne sélectionnée est déjà %1');
    }
}
